import React, { lazy, Suspense } from 'react';
import './Cards.scss';
import { Route, Routes, Navigate } from 'react-router-dom';
import AboutMe from './AboutMe/AboutMe';
import ExperienceAndEducation from './ExperienceAndEducation/ExperienceAndEducation';
import Contact from './Contact/Contact';
import { reactProjectsData, javaScriptProjectsData } from './Data/Data';

const Projects = lazy(() => import('./Projects/Projects'));
const ProjectCard = lazy(() => import('./Projects/ProjectsCards/ProjectCard'));

function Card() {
  return (
    <>
      <Suspense fallback={null}>
        <Routes>
          <Route path='/' element={<Navigate replace to='/about_me' />} />
          <Route path='/about_me' element={<AboutMe />} />
          <Route
            path='/experience_education'
            element={<ExperienceAndEducation />}
          />
          <Route path='/projects' element={<Projects />} />
          <Route path='/contact' element={<Contact />} />

          {reactProjectsData.map((project) => (
            <Route
              key={project.id}
              path={`/${project.href}`}
              element={<ProjectCard />}
            />
          ))}
          {javaScriptProjectsData.map((project) => (
            <Route
              key={project.id}
              path={`/${project.href}`}
              element={<ProjectCard />}
            />
          ))}
        </Routes>
      </Suspense>
    </>
  );
}

export default Card;
